import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-008158dc"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "title" };
import { useBuiltComponent, useBuiltComponentVariable, useComponentDisplayName, } from "src/shared/store/component-built/composables";
import { useComponentVariableChildComponentIds } from "src/shared/store/component-graph-v2/composables/useComponentVariableChildComponentIds";
import ComponentVariableManagementTree from "src/shared/v-components/component/component-tree/ComponentVariableManagementTree.vue";
import ComponentDisplayName from "src/shared/v-components/component/ComponentDisplayName.vue";
import ExtoleDrawer from "src/shared/v-components/ui/ExtoleDrawer.vue";
import { ref, toRef, computed } from "vue";
import ComponentVariableImpactTreeNodeControls from "../../campaign-component-variable/input/inheritance/ComponentVariableImpactTreeNodeControls.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ChildVariableManagementDrawer',
    props: {
        componentId: {},
        variableName: {}
    },
    emits: ["closed"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const { builtComponent } = useBuiltComponent(toRef(props, "componentId"));
        const { builtComponentVariable } = useBuiltComponentVariable(props.componentId, props.variableName);
        const componentDisplayName = computed(() => {
            var _a, _b;
            if (!((_a = builtComponentVariable.value) === null || _a === void 0 ? void 0 : _a.context.componentId)) {
                return undefined;
            }
            return useComponentDisplayName((_b = builtComponentVariable.value) === null || _b === void 0 ? void 0 : _b.context.componentId).displayName.value;
        });
        const summary = ref("");
        const { componentVariableChildComponentIds } = useComponentVariableChildComponentIds(toRef(props, "componentId"), toRef(props, "variableName"));
        const impactedComponentIds = computed(() => {
            return new Set(componentVariableChildComponentIds.value || []);
        });
        const isOpen = ref(true);
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(ExtoleDrawer, {
                modelValue: isOpen.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((isOpen).value = $event)),
                onClosed: _cache[1] || (_cache[1] = ($event) => (emit('closed'))),
                showClose: false
            }, {
                title: _withCtx(() => {
                    var _a;
                    return [
                        _createElementVNode("div", null, [
                            _createElementVNode("h1", _hoisted_1, _toDisplayString((_a = _unref(builtComponentVariable)) === null || _a === void 0 ? void 0 : _a.getDisplayName()), 1 /* TEXT */)
                        ])
                    ];
                }),
                default: _withCtx(() => {
                    var _a;
                    return [
                        _createElementVNode("p", null, [
                            _createTextVNode(" Check or uncheck the box next to each component to add or remove the "),
                            _createElementVNode("strong", null, _toDisplayString((_a = _unref(builtComponentVariable)) === null || _a === void 0 ? void 0 : _a.getDisplayName()), 1 /* TEXT */),
                            _createTextVNode(" setting. ")
                        ]),
                        _createVNode(ComponentVariableManagementTree, {
                            componentId: props.componentId,
                            "variable-name": props.variableName,
                            "active-component-ids": impactedComponentIds.value
                        }, {
                            title: _withCtx(() => [
                                _createVNode(ComponentDisplayName, { "component-id": _ctx.componentId }, null, 8 /* PROPS */, ["component-id"])
                            ]),
                            master: _withCtx(({ componentId }) => [
                                _createVNode(ComponentVariableImpactTreeNodeControls, {
                                    "app-u-i-context": 'marketer_ui',
                                    "component-id": componentId
                                }, null, 8 /* PROPS */, ["component-id"])
                            ]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["componentId", "variable-name", "active-component-ids"])
                    ];
                }),
                _: 1 /* STABLE */
            }, 8 /* PROPS */, ["modelValue"]));
        };
    }
});
